export default __webpack_public_path__ + "static/media/logo2.8d1c9740.svg";